import { EnergyLabelProductFoundResult } from "../../../data/energyLabelResponseSchema";
import styles from "./EnergyCostGraph.module.scss";
import { Badge } from "@JohnLewisPartnership/jl-design-system/dist/components/badge/Badge";

type Props = {
  energyResult: EnergyLabelProductFoundResult;
};

const EnergyCostGraph = ({ energyResult }: Props) => {
  const {
    mostEfficientEnergyCost,
    leastEfficientEnergyCost,
    ekoScore,
    energyCost,
  } = energyResult;

  return (
    <div className={styles.energyCost}>
      <div className={styles.energyCost__track}>
        <span
          className={styles.energyCost__fill}
          style={{ width: `${100 - ekoScore}%` }}
        >
          <Badge
            label={`${energyCost} - This model`}
            className={styles.energyCost__thisModel}
          />
        </span>
      </div>
      <div className={styles.energyCost__labels}>
        <div className={styles.energyCost__labelMost}>
          {mostEfficientEnergyCost}
          <span>Most efficient model</span>
        </div>
        <div className={styles.energyCost__labelLeast}>
          {leastEfficientEnergyCost}
          <span>Least efficient model</span>
        </div>
      </div>
    </div>
  );
};

export default EnergyCostGraph;
